import { FormFieldContractSummary } from "#components";
import { InputType } from "~/scad-shared/types/generic";
import {
  setComponentMapOverrides,
  setControlTypeMappingOverrides,
  type ComponentMapType,
  type ControlTypeMappingType,
} from "~/scad-shared/config";

// Project-specific component map overrides
const componentMapOverrides: Partial<ComponentMapType> = {
  [InputType.ContractSummary]: {
    component: FormFieldContractSummary,
    configureBindings: (bindings, props) => {
      bindings.endpoint = `/scad${props.misc?.endpoint}`;
    },
  },
};

// Project-specific control type mapping overrides
const controlTypeMappingOverrides: Partial<ControlTypeMappingType> = {
  contractsummary: InputType.ContractSummary,
};

// Apply overrides
setComponentMapOverrides(componentMapOverrides);
setControlTypeMappingOverrides(controlTypeMappingOverrides);

export { componentMapOverrides, controlTypeMappingOverrides };
